module.exports = __webpack_public_path__ + "img/41_29.40a465d0.png";